import React, { useState } from 'react'
import { cx } from '@emotion/css'
import { LazyImage } from '@offerzen/pinata'

import styles from './styles'

const AnimatedDino = () => {
  const [animation, setAnimation] = useState({ running: false, animated: false })

  const controlAnimation = () => {
    setAnimation({ running: true, animated: true })
    setTimeout(() => {
      setAnimation({ running: false, animated: true })
    }, 5000)
  }

  return (
    <button
      className={cx(styles.animationTrigger, animation.running && styles.dinoRun)}
      type="button"
      aria-hidden
      onClick={controlAnimation}
    >
      <LazyImage
        className={cx(styles.dinoStep1, animation.animated && styles.dinoStep1Animation)}
        loader={() => import('../../../../assets/dino-step-1.svg')}
      />
      <LazyImage
        className={cx(styles.dinoStep2, animation.animated && styles.dinoStep2Animation)}
        loader={() => import('../../../../assets/dino-step-2.svg')}
      />
    </button>
  )
}

export default AnimatedDino
